/**
 * Maximum number of hours after the scheduled shift end time that workers
 * are allowed to edit their timesheet entries (clock in, clock out, break).
 */
export const MAX_AFTER_SHIFT_END_THRESHOLD_HOURS = 6;
